import { CommonModule } from '@angular/common';
import { ConfigModule } from 'Angular/config/config.module';
import { CascadingDropdownModule } from 'Angular/features/components/dropdowns/cascading-dropdown/cascading-dropdown.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { HoldingsDatePickerInlineModule } from 'SecuritiesApp/ts/features/holdings-date-picker-inline/holdings-date-picker-inline.module';
import * as i0 from "@angular/core";
export class HoldingsHistoryTableModule {
}
HoldingsHistoryTableModule.ɵfac = function HoldingsHistoryTableModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsHistoryTableModule)(); };
HoldingsHistoryTableModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsHistoryTableModule });
HoldingsHistoryTableModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ConfigModule,
        IconModule,
        HoldingsDatePickerInlineModule,
        DisabledModule,
        LoadingSymbolModule,
        CascadingDropdownModule,
        ModalBaseModule,
        FeatureNeededModule] });
